<script>
import i18n from "@/i18n";

export default {
  page() {
    return {
      title: this.$t("title.login") || "登录",
    };
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
  },
  created() {
    if (typeof document !== 'undefined') {
      document.body.classList.add("auth-body-bg");
    }
    
    // 在浏览器环境中检查URL参数
    if (typeof window !== 'undefined' && window.location) {
      // 检查URL参数，如果有uid和token，保存到localStorage
      const urlParams = new URLSearchParams(window.location.search);
      const uid = urlParams.get('uid');
      const token = urlParams.get('token');
      const error = urlParams.get('error');
      
      if (error) {
        this.$message({
          message: '登录失败: ' + error,
          type: 'error',
        });
        // 清除URL中的参数
        if (window.history && window.location) {
          window.history.replaceState({}, document.title, window.location.pathname);
        }
      }
      
      if (uid && token) {
        // 保存用户ID到localStorage（前端使用这个作为uid）
        if (typeof localStorage !== 'undefined') {
          localStorage.setItem("user", uid);
          // 保存token到localStorage（如果需要的话）
          localStorage.setItem("access_token", token);
          
          // 使用完整页面跳转，确保页面重新加载，路由守卫能检测到 localStorage
          // 清除URL参数后跳转到首页
          setTimeout(() => {
            if (window.history && window.location) {
              window.history.replaceState({}, document.title, '/');
              window.location.href = '/';
            }
          }, 100);
        }
      }
    }
  },
  mounted() {
    if (typeof navigator !== 'undefined' && navigator.language) {
      var languagecode = navigator.language;
      languagecode = languagecode.substr(0, 2);
      i18n.locale = languagecode;
    }
    
    // 如果已经登录，重定向到首页
    if (typeof localStorage !== 'undefined') {
      const loggeduser = localStorage.getItem('user');
      if (loggeduser && this.$router) {
        this.$router.push({ name: "home" });
      }
    }
  },
  methods: {
    aicocloudLogin() {
      // 跳转到OAuth登录
      if (typeof window !== 'undefined' && window.location) {
        window.location.href = '/oauth/login';
      } else if (this.$router) {
        this.$router.push('/oauth/login');
      }
    },
  },
};
</script>

<template>
  <div class="login-page">
    <div class="home-btn d-none d-sm-block">
      <a href="https://aic.xin/">
        <i class="mdi mdi-home-variant h2 text-primary"></i>
      </a>
    </div>
    <div class="login-layout" v-loading="loading">
      <div class="login-shell">
        <div class="login-panel">
          <div class="login-content w-100">
            <div class="login-card">
              <div class="text-center">
                <a href="/" class="logo d-inline-block">
                  <img
                    src="@/assets/images/logo_dark.png"
                    class="login-logo"
                    alt="logo"
                  />
                </a>
                <h4 class="font-size-18 mt-4 mb-2">
                  {{ $t("account.login.text") }}
                </h4>
                <p class="text-muted login-subtitle">
                  使用 AICOCLOUD 账号安全登录
                </p>
              </div>

              <div class="login-action">
                <el-button
                  type="primary"
                  size="large"
                  :loading="loading"
                  @click="aicocloudLogin"
                  class="w-100 login-btn"
                >
                  AICOCLOUD登录
                </el-button>
              </div>
            </div>
          </div>
        </div>

        <div class="promo-panel d-none d-lg-flex">
          <div class="promo-content">
            <h2 class="promo-title">AICODNS</h2>
            <p class="promo-desc">
              智能 DNS 管理平台，统一纳管域名、解析策略与访问权限，提升配置效率与运维稳定性。
            </p>
            <ul class="promo-list">
              <li>支持多环境解析策略与灰度发布</li>
              <li>可视化运维视图，快速定位问题</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="page-footer text-center">
      <p class="mb-1">
        {{ $t("account.register.noaccount") }}
        <a
          href="https://account.aicocloud.com/register"
          class="font-weight-medium text-primary"
        >{{ $t("account.register.text") }}</a>
      </p>
      <div class="footer-links">
        <a href="https://aicodns.com" target="_blank" rel="noopener noreferrer">官网</a>
      </div>
      <p class="mb-0 footer-copyright">
        © 2016 Shijiazhuang MOE Information Technology Co., Ltd
      </p>
    </div>
  </div>
</template>
<style>
.login-page {
  position: relative;
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  background: linear-gradient(180deg, #f6f8fc 0%, #f2f5fb 100%);
}

.login-layout {
  flex: 1;
  min-height: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 20px 20px;
}

.login-shell {
  width: 100%;
  max-width: 1180px;
  display: grid;
  grid-template-columns: minmax(360px, 480px) 1fr;
  gap: 56px;
  align-items: center;
}

.login-panel {
  width: 100%;
}

.login-content {
  width: 100%;
}

.login-card {
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0 12px 36px rgba(31, 45, 61, 0.1);
  padding: 40px 32px;
}

.login-logo {
  width: 220px;
  max-width: 80%;
}

.login-subtitle {
  font-size: 14px;
}

.login-action {
  margin-top: 28px;
}

.login-btn {
  width: 100%;
  padding: 14px;
  font-size: 16px;
  border-radius: 8px;
}

.promo-panel {
  align-items: center;
  min-height: 360px;
}

.promo-content {
  max-width: 520px;
}

.promo-title {
  margin: 0 0 18px;
  font-size: 42px;
  font-weight: 700;
  color: #1f2d3d;
}

.promo-desc {
  margin: 0 0 18px;
  color: #5b6b7b;
  font-size: 16px;
  line-height: 1.8;
}

.promo-list {
  margin: 0;
  padding-left: 18px;
  color: #4c5b6a;
  line-height: 2;
}

.page-footer {
  padding: 16px 20px 18px;
  color: #7f8c9a;
  font-size: 13px;
}

.footer-links {
  margin: 6px 0;
}

.footer-links a {
  color: #7f8c9a;
  margin: 0 10px;
}

.footer-links a:hover {
  color: #409eff;
}

.footer-copyright {
  color: #98a6ad;
  font-size: 13px;
}

@media (max-width: 1199.98px) {
  .login-shell {
    max-width: 980px;
    gap: 32px;
    grid-template-columns: minmax(340px, 460px) 1fr;
  }

  .promo-title {
    font-size: 34px;
  }
}

@media (max-width: 991.98px) {
  .home-btn {
    position: fixed;
    top: 16px;
    right: 16px;
    z-index: 10;
  }

  .login-layout {
    align-items: center;
    padding: max(20px, env(safe-area-inset-top)) 14px 12px;
  }

  .login-shell {
    display: block;
    max-width: 500px;
  }

  .login-card {
    padding: 28px 20px;
    border-radius: 10px;
    box-shadow: 0 6px 20px rgba(31, 45, 61, 0.08);
  }

  .login-action {
    margin-top: 20px;
  }

  .page-footer {
    padding: 12px 14px max(16px, env(safe-area-inset-bottom));
  }

  .footer-links a {
    margin: 0 8px;
  }
}

@media (max-width: 360px), (max-height: 640px) {
  .login-card {
    padding: 24px 16px 20px;
  }

  .login-logo {
    width: 180px;
  }

  .login-action {
    margin-top: 16px;
  }

  .promo-title {
    font-size: 28px;
  }
}

.el-select .el-input {
  width: 100px;
}
.input-with-select .el-input-group__prepend {
  background-color: #fff;
}
</style>